module.exports = __webpack_public_path__ + "img/banner_11pick5_gd.8837aabf.jpg";